import authRules from '../authRules.js';

const submitApprovals = (user) => {
  const { approvalsSubmit } = user.securityLevels;
  if (approvalsSubmit >= authRules.submitApprovals.approvalsSubmit) {
      return true;
  } else {
      return false;
    }
  }

export default submitApprovals;